import { Injectable } from '@angular/core';
import {Chart} from 'angular-highcharts';

@Injectable({
  providedIn: 'root'
})
export class CommonChartService {
  chartCommonData(chartData) {
    return new Chart({
      chart: {
        type: 'pie',
        height: 220,
        shadow: false,
        plotBackgroundColor: 'rgba(0, 0, 0, 0)',
        plotShadow: false,

      },

      title: {
        text: ''
      },
      tooltip: {
        formatter: function () {
          if (this.point.options.extraValue >= 0) {
            if (chartData.name === 'tutionOutState' || chartData.name === 'tutionInState') {
              return '$' + this.point.options.extraValue;
            } if (chartData.name === 'RaceEtinicity') {
              return (((this.point.options.extraValue) / chartData.totalValue) * 100).toFixed(2) + ' %';
            } else {
              return this.point.options.extraValue + ' %';
            }
          }
        },
        backgroundColor: {
          linearGradient: [0, 0, 0, 60],
          stops: [
            [0, '#FFFFFF'],
            [1, '#E0E0E0']
          ]
        },
        borderWidth: 1,
        borderColor: '#AAA'
      },
      legend: {
        layout: 'vertical',
        floating: true,
        backgroundColor: '#000',
        align: 'left',
        verticalAlign: 'top',
        enabled: true
      },
      series: [{
        data: chartData.data
      }],
      plotOptions: {
        pie: {
          center: [45, 45],
          size: 220,
          cursor: 'pointer',
          dataLabels: {
            distance: -30,
            style: { fontSize: '17px' },
            enabled: true,
            formatter: function() {
              return '';
            },
            shadow: false
          },
          borderColor: '#eee',
          borderWidth: 1
        }
      }
    });
  }

}
